import PropTypes from 'prop-types'
import React from 'react'
import { CardImg, Col, Container, Row } from 'reactstrap'


const propTypes = {
  title : PropTypes.string,
  lead  : PropTypes.string,
  logo  : PropTypes.string
}

const PublicHeader = ({ title, lead, logo }) => (
  <div className="header py-7 py-lg-8 pt-lg-9"
    style={{
      background: 'linear-gradient(180deg, #9db8ce 100%, #ffffffff 0%)',
      // background: 'linear-gradient(180deg, #eaf3f9 0%, #ffffff 70%)',
      titleColor: '#2e3a46',
      leadColor: '#5b6b7a'
    }}
  >
    <Container>
      <div className="header-body text-center mb-3">
        <Row className="justify-content-center">
          <Col className="px-5" lg="6" md="8" xl="5">
              <div className='text-center mb-3'>
                  <CardImg src={ `${process.env.PUBLIC_URL || ''}/assets/refresh_logo_white.png` }/>
                </div>
            {/* {
              logo ? (
                <div className='text-center mb-3'>
                  <CardImg src={ 'https://production.belleandkate.com/assets/room_logo_white-cd01eee5c4ab6d6fd7c1eb6ab315b2bda22d9799a0aeb38b47372a19f495b41f.png' }/>
                </div>
              )
                : null
            } */}

            { title ? (
              <h1 className="text-white">{ title }</h1>
            ) : null }
            {/* { lead ? (
              <p className="text-lead text-white">{ lead }</p>
            ) : null } */}
          </Col>
        </Row>
      </div>
    </Container>

  </div>
)

PublicHeader.propTypes = propTypes

export default PublicHeader
